export const menu :any = {
  url: '/plants/%s/category/%s/type/%s'
}
